import React from "react";
import { Row, Col, Layout } from "antd";

//
//component
import TriggerInit from "./trigger/trigger-init";
import BailiffLayout from "./component/bailiff_layout";
// import TriggerAudio from "./trigger/trigger_audio";
// import DialogBailiffControl from "./dialog/dialog_bailiff_control";
import TriggerSpeaker from "./trigger/trigger_speaker";
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import BailiffBanned from "./component/bailiff_banned";
import BailiffTitle from "./component/bailiff_title";
import DialogAudioBottom from "component/audio/audio_bottom/dialog_audio_bottom";
import BailiffLoading from "./component/bailiff_loading";

//redux
//selector
//actions
//utils
//hook
//str

const { Content } = Layout;
const BailiffDialog = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return <BailiffLayout />;
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={<BailiffTitle />} />
      <Content className="content">
        <Row justify={"center"}>
          <Col xl={12} xs={24}>
            {renderBody()}
            <BailiffBanned />
            <BailiffLoading />
          </Col>
          <DialogAudioBottom />
        </Row>
      </Content>
      <TriggerInit />
      <TriggerSpeaker />
    </Layout>
  );
};
export default BailiffDialog;
